module.exports = __webpack_public_path__ + "img/gallery02.03f49415.png";